﻿import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import render from '@tk/utilities/tk.render';

export default class KWNavigationSidebar extends TKNavigationSidebar {
    constructor() {
        super();
    }

    connectedCallback(): void {
        super.connectedCallback();
    }

    async handleClickLink(event: Event): Promise<void> {
        if (!this.isMobile) return;
        const target = event.target as HTMLAnchorElement;
        let element: HTMLAnchorElement | null;
        if (target.hasAttribute('data-tk-nav-id')) {
            element = target;
        } else {
            element = target.closest('[data-tk-nav-id]');
        }

        if (!element) return;
        event.preventDefault();
        if (
            !element.parentElement?.classList.contains(this.hasChildrenClassName)
            && !element.parentElement?.hasAttribute('data-tk-nav-page')
        ) {
            window.location.href = element.href;
            this.closeNavigation();
            return;
        }
        const id = element.getAttribute('data-tk-nav-id');

        if (!id) return;
        if (this.existPage(id)) {
            const page = this.getPage(id);
            if (!page) return;
            this.insertPage(page.element);
            TKNavigationSidebar.jumpToPage(page.element);
            this.removeLastPageFromDOM();
        } else {
            const response = await this.getTemplate(id);
            this.responseNextLevel(response);
        }
    }

    async switchToMobile() {
        if (this.isMobileActive) return;
        this.isMobileActive = true;
        this.closeButton && (this.closeButton.hidden = false);
        if (!this.wrapper) return;
        this.desktopView = this.wrapper.innerHTML;

        if (!this.mobileView) {
            const response = await this.getTemplate(this.currentMenuId!);
            const html = render(response.dataAsJson.showItems);
            if (!html) return;
            this.wrapper.replaceChildren(html);
            const navigation = html.querySelector('[data-tk-nav-page]');
            navigation && this.addPage(navigation);
        } else {
            this.wrapper.innerHTML = '';
            this.wrapper.insertAdjacentHTML('afterbegin', this.mobileView);
        }
    }
}
